import { getAuth } from 'firebase/auth';

import {
  client,
  firebaseApp,
  getSubject,
  logout,
  useData,
  useSubject,
} from '@workspace/ui';

export const auth = getAuth(firebaseApp);

export async function getIdentity() {
  const subject = await getSubject(auth);
  if (!subject) {
    return null;
  }
  // A Firebase session without a learner row is unusable, so drop it and let
  // the caller redirect to sign-in rather than surfacing a loader error.
  return client.request('GET /me', {}).catch(async (error) => {
    await logout(auth).catch(() => undefined);
    console.error(error);
    return null;
  });
}

export function useUser() {
  const subject = useSubject(auth);
  return useData('GET /me', {}, { enabled: !!subject?.uid, staleTime: Infinity });
}
